import React from "react";
import { useTranslation } from "react-i18next";
import { EmailBuilderBoundedRange } from "../../shell/panel/blockSettings/EmailBuilderBlockSettingsShared";
import { SettingSection } from "../controls/SettingSection";
import { baselineSpacerHeight } from "../../domain/baselines";
import type { SpacerBlock } from "../../domain/types";
import type { BlockSettingsProps } from "./types";

export function SpacerBlockSettings({
  block,
  patch,
}: BlockSettingsProps & { block: SpacerBlock }) {
  const { t } = useTranslation();

  return (
    <SettingSection sectionId="size" title={t("Size")}>
      <EmailBuilderBoundedRange
        label={t("Height (px)")}
        value={block.height}
        min={8}
        max={120}
        defaultValue={baselineSpacerHeight()}
        onChange={height => {
          if (height === undefined) {
            return;
          }
          patch({ height });
        }}
      />
    </SettingSection>
  );
}
